import React from "react";


export default function Skeleton() {
    return (
        <>
            <div className="skeleton-container">
                <div className="skeleton-author-conatiner">
                    <div className="skeleton-author"></div>
                    <div className="skeleton-author"></div>
                </div>
                <div className="skeleton-quote"></div>
                <div className="skeleton-btn-container">
                    <div className="skeleton-buttons"></div>
                    <div className="skeleton-buttons"></div>
                </div>
            </div>

            <div className="skeleton-container">
                <div className="skeleton-author-conatiner">
                    <div className="skeleton-author"></div>
                    <div className="skeleton-author"></div>
                </div>
                <div className="skeleton-quote"></div>
                <div className="skeleton-btn-container">
                    <div className="skeleton-buttons"></div>
                    <div className="skeleton-buttons"></div>
                </div>
            </div>

            <div className="skeleton-container">
                <div className="skeleton-author-conatiner">
                    <div className="skeleton-author"></div>
                    <div className="skeleton-author"></div>
                </div>
                <div className="skeleton-quote"></div>
                <div className="skeleton-btn-container">
                    <div className="skeleton-buttons"></div>
                    <div className="skeleton-buttons"></div>
                </div>
            </div>
        </>
    )
}
